/* eslint-disable max-len */
import { CircularProgress } from '@mui/material';
import React from 'react';

const Loading = (props) =>
{
	const { progress } = props;

	return (
		<div className='flexRow'>
			<div className='flexRow loaderCntnr fullWidthLoader'>
				<CircularProgress />
			</div>
			<div className='flexRow loaderCntnr pdngVSM'>
				{progress && <p>Folder uploading may take sometime, so please wait sometime!!!!</p>}
			</div>
		</div>

	);
};

export default Loading;